import { translate } from "../../Translations/translatorService";
import { STAGE_DATA_COMPLETED } from "../../Stages/StagesCase";
import { RentalContract } from "../../../types/Products/RentalContract";

export const getRentalContractBadges = (product: RentalContract) => {
  let badges = [];

  if (product.productClassName !== "rentalContract") {
    return [];
  }

  if (product.stage && product.stage >= STAGE_DATA_COMPLETED && product.caseCategory !== "advisory") {
    badges.push({
      text: translate("rentalContract.reasonForDispute.values." + product.reasonForDispute),
      isActive: true,
    });
  }

  if (product.stage && product.stage >= STAGE_DATA_COMPLETED) {
    badges.push({
      text: translate(product.productClassName + ".caseCategory.values." + product.caseCategory, "Noch nicht gesetzt"),
      isActive: true,
    });
  }

  badges.push({
    text: translate("rentalContract.contractPartyType.values." + product.contractPartyType, "Noch nicht gesetzt"),
    isActive: true,
  });

  if (product.additionalOpposingParties?.length > 0) {
    badges.push({
      text: "Mehrere Gegenseiten",
      isActive: true,
    });
  }

  return badges;
};
